import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Button, Radio, Tabs } from "antd";
import MinePerformance from "./MinePerformance";
import MyTeamPerformance from "./MyTeamPerformance";
import { useHistory } from "react-router-dom";
import CreatingPerformance from "./CreatingPerformance";
import { connect, useSelector } from "react-redux";
import { RightOutlined } from "@ant-design/icons";

import {
  getMenuList,
  getSupervisorList,
  getUserInfo,
  getUserList,
  getUserRoleId,
} from "redux/selectors";
import { CALL_FEATCH_API } from "common/API";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import TabsList from "molecules/TabsList";
import { some } from "lodash";
import CreateEditPerformance from "./CreateEditPerformance";

const Styleddiv = styled.div`
  .ant-radio-button-wrapper-checked:not(
      [class*=" ant-radio-button-wrapper-disabled"]
    ).ant-radio-button-wrapper:first-child {
    border-right-color: #ccc;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    z-index: 1;
    color: #000;
    background: #c2fae5;
    border-color: #c2fae5;
  }
  .ant-radio-button-wrapper-checked:not(
      .ant-radio-button-wrapper-disabled
    )::before {
    background-color: #ccc;
  }

  .title-button {
    display: flex;
    justify-content: space-between;
  }
  .breadcrumb {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    color: #1f243b;
  }
  .performance-management1 {
    font-weight: 400;
    font-size: 16px;
    color: #636980;
    cursor: pointer;
  }
  .right-icon {
    width: 10px;
    height: 10px;
    margin-bottom: 10px;
  }
  .performance-management {
    font-weight: 400;
    font-size: 18px;
  }
  .performance-contract {
    width: 200px;
    height: 34px;
    border-radius: 8px;
    background-color: #c2fae5;
    font-weight: 400;
    font-size: 16px;
    color: #1f243b;
    border: none;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: black !important;
  }
  .ant-tabs-ink-bar {
    background-color: black !important;
  }
  .ant-tabs-tab:hover .ant-tabs-tab-btn {
    color: black !important;
  }
  .ant-btn[disabled],
  .ant-btn[disabled]:hover {
    background: rgb(194, 250, 229);
  }
`;

const PerformanceManagement = ({ supervisorList }) => {
  const [editPerformance, setEditPerformance] = useState(false);
  const [selectedItem, setSelectedItem] = useState("performance-contract"); // default is 'middle'
  const [editPerformanceData, setEditPerformanceData] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const history = useHistory();
  const userInfo = useSelector(getUserInfo);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);
  const userList = useSelector(getUserList);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isDraft, setIsDraft] = useState(false);
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [selectedUserRecord, setSelectedUserRecord] = useState({});
  const [isbreadcrum, setBreadCrum] = useState(false);

  let appraisarStatus = userList?.some((obj) =>
    some(obj?.appraisalInformation, { appraiser: userInfo?.userid })
  );
  useEffect(() => {
    if (editPerformance) {
      setEditPerformanceData(true);
    } else {
      setEditPerformanceData(false);
    }
  }, [editPerformance]);
  useEffect(() => {
    if (editPerformance) {
      setActiveTab(1);
    }
  }, [editPerformance]);

  const onChange = (key) => {
    setActiveTab(key);
  };

  const getEmployeeList = useMemo(() => {
    return supervisorList?.find((item) => userInfo.userid === item.userid);
  }, [supervisorList, userInfo.userid]);

  const fetchData = async () => {
    if (!getEmployeeList?.employeeId) return;
    try {
      const response = await CALL_FEATCH_API(
        `appraisal/myteam?employeeid=${getEmployeeList.employeeId}`,
        "get"
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  let Menulist = menuList[userRoleId] || Object.values(menuList)[0] || menuList;

  Menulist = Array.isArray(Menulist) ? Menulist : [];
  const { state } = useLocation();
  const [tabId, setTabId] = useState(state?.tabId || "mineappraisal");

  const handleTabSelect = (id) => {
    setTabId(id);
  };

  const create = () => {
    history.push("/CreateEdit");
  };
  const mineAppraisalAccess = Menulist.find(
    (item) => item.key === "mineappraisal"
  )?.access;

  const teamAppraisalAccess = Menulist.find(
    (item) => item.key === "managerappraisal"
  )?.access;

  const items = [
    mineAppraisalAccess
      ? {
          key: 1,
          label: "Mine",
          children: (
            <MinePerformance
              editPerformance={editPerformance}
              setEditPerformance={setEditPerformance}
              selectedRecord={selectedRecord}
              setSelectedRecord={setSelectedRecord}
              selectedItem={selectedItem}
            />
          ),
        }
      : null,
    teamAppraisalAccess
      ? {
          key: 2,
          label: "My Team",
          children: (
            <MyTeamPerformance
              editPerformance={editPerformance}
              setEditPerformance={setEditPerformance}
              selectedRecord={selectedRecord}
              setSelectedRecord={setSelectedRecord}
              isDraft={isDraft}
              setIsDraft={setIsDraft}
              isAddEdit={isAddEdit}
              setIsAddEdit={setIsAddEdit}
              setSelectedUserRecord={setSelectedUserRecord}
              selectedItem={selectedItem}
              setBreadCrum={setBreadCrum}
            />
          ),
        }
      : null,
  ].filter(Boolean);

  useEffect(() => {
    if (mineAppraisalAccess) {
      setTabId("mineappraisal");
      setActiveTab(1);
    } else if (teamAppraisalAccess) {
      setTabId("managerappraisal");
      setActiveTab(2);
    }
  }, [mineAppraisalAccess, teamAppraisalAccess]);

  useEffect(() => {
    if (state?.tabId) {
      setTabId(state.tabId); // "managerappraisal" or "mineappraisal"

      // setActiveTab should be string-based and based on mapping
      if (state.tabId === "managerappraisal") {
        setActiveTab(2);
        setTabId("managerappraisal");
      } else if (state.tabId === "mineappraisal") {
        setActiveTab(1);
        setTabId("mineappraisal");
      }

      setIsDraft(false);
    }
    if (state?.selectedItem) {
      setSelectedItem(state.selectedItem); // e.g., "performance-contract"
    }
  }, [state]);
  return (
    <Styleddiv>
      {!isAddEdit && (
        <div className="title-button">
          <div className="performance-management">Performance Management</div>
        </div>
      )}

      {/* {editPerformance && !isDraft && (
        <>
          <div className="breadcrumb">
            <p
              className="performance-management1"
              onClick={() => {
                setEditPerformance(false);
                history.push(`/performancemanagement`, { tabId: "2" });
              }}
            >
              Performance Management
            </p>
            <RightOutlined className="right-icon" />
            <p>Editing Performance</p>
          </div>
        </>
      )} */}
      {!isAddEdit && (
        <div className="mt-3">
          <Radio.Group
            value={selectedItem}
            onChange={(e) => setSelectedItem(e.target.value)}
            style={{
              boxShadow: "none",
            }}
          >
            <Radio.Button
              value="performance-contract"
              style={{
                boxShadow: "none",
              }}
            >
              Performance Contract
            </Radio.Button>
            <Radio.Button
              value="performance-management"
              style={{
                boxShadow: "none",
              }}
            >
              Performance Appraisal
            </Radio.Button>
          </Radio.Group>
        </div>
      )}

      {!isAddEdit && (
        <Tabs activeKey={activeTab} items={items} onChange={onChange} />
      )}
      {isAddEdit && (
        <CreateEditPerformance
          setIsAddEdit={setIsAddEdit}
          isAddEdit={isAddEdit}
          selectedUserRecord={selectedUserRecord}
          isbreadcrum={isbreadcrum}
        />
      )}
      {/* {editPerformance && (
        <MyTeamPerformance
          activeKey={activeTab}
          setActiveKey={setActiveTab}
          editPerformance={editPerformance}
          setEditPerformance={setEditPerformance}
          editPerformanceData={editPerformanceData}
          selectedRecord={selectedRecord}
          setSelectedRecord={setSelectedRecord}
          isDraft={isDraft}
          setIsDraft={setIsDraft}
        />
      )} */}
    </Styleddiv>
  );
};

const mapStateToProps = (state) => ({
  supervisorList: getSupervisorList(state),
});

export default connect(mapStateToProps, null)(PerformanceManagement);
